// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"154bc754","265":"7ab55526","277":"2df20ce9","411":"7498619b","453":"4d7fa001","511":"6cad6996","667":"51eac345","884":"9ef0ead1"}[chunkId] + ".chunk.js";
};